"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateReducer = exports.StateReducer = exports.toggleLabels = exports.selectTab = exports.StateActionType = exports.TabType = void 0;
const react_1 = require("react");
var TabType;
(function (TabType) {
    TabType[TabType["None"] = 0] = "None";
    TabType[TabType["Search"] = 1] = "Search";
    TabType[TabType["Description"] = 2] = "Description";
    TabType[TabType["Hide"] = 3] = "Hide";
})(TabType || (exports.TabType = TabType = {}));
var StateActionType;
(function (StateActionType) {
    StateActionType["SelectTab"] = "selectTab";
    StateActionType["ToggleLabels"] = "toggleLabels";
})(StateActionType || (exports.StateActionType = StateActionType = {}));
const selectTab = (tab) => ({
    type: StateActionType.SelectTab,
    payload: tab,
});
exports.selectTab = selectTab;
const toggleLabels = (state) => ({
    type: StateActionType.ToggleLabels,
    payload: state,
});
exports.toggleLabels = toggleLabels;
function StateReducer(state, action) {
    const { type, payload } = action;
    switch (type) {
        case StateActionType.SelectTab: {
            const lastState = state.currentTab;
            return Object.assign(Object.assign({}, state), { currentTab: lastState === payload ? TabType.None : payload });
        }
        case StateActionType.ToggleLabels: {
            return Object.assign(Object.assign({}, state), { isLabelVisible: payload });
        }
        default:
            return state;
    }
}
exports.StateReducer = StateReducer;
function useStateReducer(state) {
    return (0, react_1.useReducer)(StateReducer, state);
}
exports.useStateReducer = useStateReducer;
